import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Product Routes and Pages
 */
const ListContactPage = React.lazy(() => import("./ListContactPage"));
const EditContactPage = React.lazy(() => import("./EditContactPage"));

const ContactRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListContactPage />} />
      <Route exact path="/edit/:id" element={<EditContactPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default ContactRoutes;
